import { VendorBuyingAgreementBuyOpportunityDetails } from '../../../components/Vendor';

export function BuyingAgreementBuyOpportunityDetails() {
  return <VendorBuyingAgreementBuyOpportunityDetails />;
}
